import { profileUrl } from "./endpoints.js";
const profileDetailsCacheKey = ({
  accountId,
  accountIdType
}) => [`${profileUrl}-details`, { accountId, accountIdType }];
const profileScopeCacheKey = ({
  accountId,
  accountIdType
}) => [`${profileUrl}-scope`, { accountId, accountIdType }];
export {
  profileDetailsCacheKey,
  profileScopeCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
